export default {
  basePath: process.env.VUE_APP_API_URL,
  perPage: 25,
  // perPageOptions: [25, 50, 100, 250, 500, 1000],
  perPageOptions: [25, 50, 100],
  version: process.env.VUE_APP_WEBVERSION,
}
